<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

      v-card(flat)
        v-card-title.px-5
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="closeDialog()" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.primary500--text {{ shipping.name }}

        v-card-text.pa-0
          v-form(ref="form")

            v-row.px-5(align='center')
              v-col
                .s1.basic800--text {{ $t('enable_this_courier') }}
              v-col.shrink
                y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="shipping.enabled" @change="onUpdateLocalDelivery(shipping)")
            v-divider.basic300
            .options(v-if="shipping.enabled")
              v-row.px-5(align='center')
                v-col
                  .p1.basic800--text {{ $t('set_preferred_delivery') }}
                v-col.shrink
                  y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="isPreferred")
              v-divider.basic300

              .methods.px-5.mt-4
                template(v-if="localdelivery.channel === 'ys_malaysia'")
                  .p1.basic800--text {{ $t('select_parcel_delivery') }}
                  .delivery.mt-2(v-for="choice in shipping.choices" :key="choice.service_id")
                    y-checkbox.my-auto.mx-0.pa-0(v-model="shippingObject(choice).enabled" hide-details @change="updateLocalDelivery(shippingObject(choice))")
                      template(v-slot:label)
                        div.s2.my-auto {{ choice.service_type == 'car' ? 'Car' : 'Motorcycle' }}
                    .details.ml-8.mt-n2
                      .c1.basic600--text {{ choice.item_type }}
                      div.d-flex.mt-1
                        eva-icon.mb-n2.mr-1(name="cube-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="16" height="16")
                        .c1.basic600--text.my-auto {{ choice['size_limit'] }}. {{ choice['weight_limit'] }}
                
                template(v-else)
                  .p1.basic800--text {{ $t('select_parcel_delivery') }}
                  .delivery.mt-2(v-for="choice in shipping.choices" :key="choice.service_id")
                    y-checkbox.my-auto.mx-0.pa-0(v-model="shippingObject(choice).enabled" hide-details @change="updateLocalDelivery(shippingObject(choice))")
                      template(v-slot:label)
                        div.s2.my-auto {{ choice.service_type == 'instant' ? 'Instant' : 'Same day' }}
                    .details.ml-8.mt-n2
                      .c1.basic600--text {{ choice.item_type }}
                      div.d-flex.mt-1
                        template(v-if="choice.size_limit")
                          eva-icon.mb-n2.mr-1(name="cube-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="16" height="16")
                          .c1.basic600--text.my-auto {{ choice['size_limit'] }}. {{ choice['weight_limit'] }}

              v-divider.basic300.my-4

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LocalDeliveryMethod',
  props: ['open', 'localdelivery', 'shipping'],
  data: () => ({
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isPreferred: {
      get() {
        return this.localdelivery.preferred === this.shipping.service_id
      },
      set(newValue) {
        if (newValue) {
          this.localdelivery.preferred = this.shipping.service_id
        } else {
          this.localdelivery.preferred = null
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    shippingObject(choice) {
      let selectedShippings = this.localdelivery.available_shipping.filter(f => f.enabled)
      let selectedShipping = selectedShippings.filter(f => f.service_id === choice.service_id)
      let isSelected = selectedShipping.length > 0
      return { ...choice, enabled: isSelected, data: choice }
    },
    closeDialog () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.showModal = !this.showModal
    },
    updateLocalDelivery (shipping) {
      let selectedShippings = this.localdelivery.available_shipping.filter(f => f.enabled)
      let selectedShipping = selectedShippings.find(f => f.service_id === shipping.service_id)
      if (selectedShipping) {
        this.$set(this.localdelivery.available_shipping[this.localdelivery.available_shipping.findIndex(f => f.service_id === shipping.service_id)], 'enabled', false)
      } else {
        this.$set(this.localdelivery.available_shipping[this.localdelivery.available_shipping.findIndex(f => f.service_id === shipping.service_id)], 'enabled', true)
      }
      this.onUpdateLocalDelivery(shipping)
    },
    onUpdateLocalDelivery (shipping) {
      this.$emit('update-enabled', shipping)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "enable_this_courier": "Enable this courier",
    "set_preferred_delivery": "Set as preferred delivery option",
    "select_parcel_delivery": "Select parcel delivery method"
  },
  "id": {
    "enable_this_courier": "Aktifkan kurir ini",
    "set_preferred_delivery": "Atur sebagai pilihan pengiriman yang disukai",
    "select_parcel_delivery": "Pilih metode pengiriman paket"
  }
}
</i18n>
